export default __webpack_public_path__ + "static/fox-love-1c525f1eae169ec4a220e9dc3a70458b.png";